export const scheduleKeys = {
	printSchedule: (eventId: string | undefined, useSessions?: boolean) => ['PRINT_SCHEDULE', eventId, useSessions] as const
};
